import React, { useState, useRef } from "react";
import { useQuery, useDetail } from "seed/gql";
import { usePost } from "seed/api";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/collections/forms/ColumnFormView.view";

function ColumnCreateForm({ 
  flow, 
  collectionId, 
  onSave = () => {},
  closeModal = () => {}
}) {

  const initialColumns = [{
    final: {
      "name": crypto.randomUUID().replace(/-/g, ''),
      "label": "",
      "type": "string",
    },
    action: "create"
  }];

  const formRef = useRef(null);
  const [error, setError] = useState(null);

  const reqCollection = useDetail(`{
    collection {
      name
      schema
      type
      uiSettings
    }
  }`, collectionId);

  const [callSet, reqSet] = usePost("/collections/create_column", {
    onCompleted: (data) => {
      onSave(data);
      closeModal();
    },
    onError: (error) => {
      if(error.status == 409) setError(l("Ya existe un campo con ese nombre%CA032"));
      else setError(l("Ocurrió un error al crear el campo%CA033"));
    }
  });

  const qCollections = useQuery(`{
		collections {
			id
			name
      uiSettings
      flow {
        name
      }
		}
	}`, `(flow.user.id=${flow?.user?.id} AND is_active=true AND flow.is_active=true AND flow.is_current_version=true)`);

  const onSubmit = (values) =>
    callSet({
      ...values,
      collection_id: collectionId,
      column: values.structure[0].final,
    });

  if (reqCollection.loading) return <Loading />;
  if (reqCollection.error) return "Error";

  const { collection = {} } = reqCollection.data || {};
  const { collections = [] } = qCollections.data || {};

  return <View
    formRef={formRef}
    error={error}
    isLoading={reqSet.loading}
    initialColumns={initialColumns}
    flow={flow}
    collection={collection}
    collections={collections}
    onSubmit={onSubmit}
  />;

}

export default ColumnCreateForm;